import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core";

import type { ErrorJWTResponse, OrderStoreType, ResponseToken, TokenResult } from "../interface";
import { getAuthAkeronJWT } from "../Composables/getAkeronData";
import { Result, Type } from "../../../interface";




const initialValue = (): OrderStoreType => {
    return {
        type_service: '',
        cliente_name: '',
        phone: '',
        address: '',
        province_name: '',
        city: '',
        dni: '',
        email: '',
        postalCode: '',
        remarks: '',
        external_code: ''
    }
}

const initialService = (): Result => {
    return {
        service: {
            id: 0,
            name: '',
            type: Type.Ship,
            description: ''
        },
        price: 0,
        price_iva: 0,
        min_delivery: new Date(),
        max_delivery: new Date(),
        description: '',
        pickup: undefined,
        address: undefined,
        hours: []
    }
}


export const useOrderDetail = defineStore('order-detail', () => {


    // PROPERTIES
    const orderDetailState = ref(useLocalStorage<OrderStoreType>('order-detail', initialValue() ))
    const akeronJWTStore = ref<TokenResult | null>(null)
    const akeronService = ref(useLocalStorage<Result>('akeron-service', initialService()))

    
    // GETTERS
    const getorderDetailState = computed(() => orderDetailState.value)
    const getAkeronJWTStore = computed(() => akeronJWTStore.value)
    const getAkeronService = computed(() => akeronService.value)


    // ACTIONS

    // funcion para validar la respuesta del token
    function isValidResponseToken(response: ResponseToken | ErrorJWTResponse): response is ResponseToken {
        return 'result' in response && 
               Array.isArray(response.result) && 
               response.result.length > 0 && 
               response.result[0] !== null &&
               'api_token' in response.result[0];
    }


    const updateJWTAkeron = (jwtArray: TokenResult[]): void => {
        if (jwtArray && jwtArray.length > 0 && jwtArray[0]) {
            // Asignamos el primer objeto del array que contiene el token
            akeronJWTStore.value = jwtArray[0];
        } else {
            console.log("El jwt que envia por parametro no está en el formato correcto o está vacío");
        }
    }


    const getJWTAkeron = async(client_api: string, client_secret: string): Promise<true | null> => {

        try {
            const JWT = await getAuthAkeronJWT(client_api, client_secret)

            if(isValidResponseToken(JWT)) {
                updateJWTAkeron(JWT.result)
                
                return true
            } else {
                return null
            }

        } catch (error) {
            console.log(error)
            return null
        }
    }




    const updateOrderDetails = (orderDetail: OrderStoreType): void => {
        orderDetailState.value = orderDetail
    }


    const updateAkeronService = (service: Result): void => {
        akeronService.value = service
    }


    const resetOrderDetails = (): void => {
        localStorage.removeItem('order-detail')
        orderDetailState.value = initialValue()
    } 


    const resetAkeronService = (): void => {
        localStorage.removeItem('akeron-service')
        akeronService.value = initialService()
    }




    return {
        // PROPERTIES


        // GETTERS
        getorderDetailState,
        getAkeronJWTStore,
        getAkeronService,   

        // ACTIONS
        getJWTAkeron,
        updateOrderDetails,
        updateAkeronService,
        resetOrderDetails,
        resetAkeronService,

    }
})